import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import './style/questionData.scss';

import ComboInput from '../ComboInput';
import Shop from '../Shop';
import CheckboxInput from '../CheckboxInput';
import OpenCheckbox from '../OpenCheckbox';
import StockCheckbox from '../StockCheckbox';
import RadioInput from '../RadioInput';
import Plan from '../Plan';
import FileInput from '../FileInput';
import CarsCheckbox from '../CarsCheckbox';
import OpenRadioInput from '../OpenRadioInput';
import TextareaInput from '../TextareaInput';
import LocaleBox from '../LocaleBox';
import TagInput from '../TagInput';

import TemplateIlustrativo from './images/template-ilustrativo.png';

const renderPWithHtmlContent = htmlContent => (
	<p className="content">{ ReactHtmlParser(htmlContent) }</p>
);

const renderSpanWithHtmlContent = htmlContent => (
	<span>{ ReactHtmlParser(htmlContent) }</span>
);

const QuestionData = (props) => {
	const {
		question,
		typeField,
		nameField,
		placeholderField,
		valueField,
		onGetValueField,
		disabledField,
		messageErrorField,
		classField,
		classContainer,
		onChangeField,
		required,
		options,
		meta,
		questions,
		answers,
		filial,
		changeFilial,
		removeFilial,
	} = props;

	if (question === '' || question === undefined) {
		return null;
	}

	if (typeof meta.answer_condition !== 'undefined') {
		const answerConditional = questions.find(
			questionFind => (
				questionFind.valueField === meta.answer_condition.answer
			),
		);

		if (typeof answerConditional === 'undefined') {
			return null;
		}
	}

	switch (typeField) {
	case 'combo-text':
		return (
			<ComboInput
				question={question}
				typeField={typeField}
				nameField={nameField}
				placeholderField={placeholderField}
				valueField={valueField}
				onGetValueField={onGetValueField}
				disabledField={disabledField}
				messageErrorField={messageErrorField}
				classField={classField}
				classContainer={classContainer}
				mask={meta.mask_type}
				onChangeField={onChangeField}
				required={required}
			/>
		);
	case 'collection-fields':
		return (
			<Shop
				question={question}
				typeField={typeField}
				nameField={nameField}
				placeholderField={placeholderField}
				valueField={valueField}
				onGetValueField={onGetValueField}
				disabledField={disabledField}
				messageErrorField={messageErrorField}
				classField={classField}
				classContainer={classContainer}
				onChangeField={onChangeField}
				required={required}
				meta={meta}
				filial={filial}
				changeFilial={changeFilial}
				removeFilial={removeFilial}
			/>
		);
	case 'checkbox':
		return (
			<div className={`component-question-data ${classContainer}`}>
				<p>
					<span>{ question }</span>
					{ required ? <span className="required">*Campos de preenchimento obrigatório.</span> : '' }
				</p>
				<CheckboxInput
					value={valueField}
					valueField={valueField}
					nameField={nameField}
					disabledField={disabledField}
					classField={classField}
					classContainer={classContainer}
					onChangeField={onChangeField}
					options={options}
				/>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	case 'open-checkbox':
		return (
			<div className={`component-question-data mb-4 p-0 ${classContainer}`}>
				{ (meta.message !== undefined && meta.message.show)
					? (
						<div className="content-box-description mb-4">
							{meta.message.title ? <p className="title">{meta.message.title}</p> : ''}
							{meta.message.content ? renderPWithHtmlContent(meta.message.content) : ''}
						</div>
					) : ''
				}

				<p className="mb-2">
					{ renderSpanWithHtmlContent(question) }
					{ required ? <span className="required">*Campos de preenchimento obrigatório.</span> : '' }
				</p>
				<OpenCheckbox
					question={question}
					required={required}
					value={valueField}
					valueField={valueField}
					nameField={nameField}
					disabledField={disabledField}
					classField={classField}
					classContainer={classContainer}
					onChange={onChangeField}
					options={options}
					meta={meta}
					messageErrorField={messageErrorField}
					questions={questions}
					maxInput={meta.maxInput !== undefined ? meta.maxInput : 2}
				/>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	case 'stock-checkbox':
		return (
			<StockCheckbox
				question={question}
				required={required}
				value={valueField}
				valueField={valueField}
				nameField={nameField}
				disabledField={disabledField}
				classField={classField}
				classContainer={classContainer}
				onChange={onChangeField}
				options={options}
				meta={meta}
				messageErrorField={messageErrorField}
				questions={questions}
			/>
		);
	case 'cars-checkbox':
		return (
			<div className={`component-question-data ${classContainer}`}>
				<p>
					<span>{ question }</span>
					{ required ? <span className="required">*Campos de preenchimento obrigatório.</span> : '' }
				</p>
				<CarsCheckbox
					question={question}
					required={required}
					value={valueField}
					valueField={valueField}
					nameField={nameField}
					disabledField={disabledField}
					classField={classField}
					classContainer={classContainer}
					onChange={onChangeField}
					options={options}
					meta={meta}
					messageErrorField={messageErrorField}
					questions={questions}
				/>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	case 'radio':
		return (
			<div className={`component-question-data p-0 mb-4 ${classContainer}`}>
				{ (meta.message !== undefined && meta.message.show)
					? (
						<div className="content-box-description mb-4">
							{meta.message.title ? <p className="title">{meta.message.title}</p> : ''}
							{meta.message.content ? renderPWithHtmlContent(meta.message.content) : ''}
						</div>
					) : ''
				}

				<p className="mb-2">
					<span>{ question }</span>
					{ required ? <span className="required">*Campos de preenchimento obrigatório.</span> : '' }
				</p>

				<RadioInput
					value={valueField}
					nameField={nameField}
					disabledField={disabledField}
					classField={classField}
					classContainer={classContainer}
					onChange={onChangeField}
					options={options}
					valueField={valueField}
				/>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	case 'open-radio-input':
		return (
			<div className={`component-question-data p-0 mb-4 ${classContainer}`}>
				<p>
					{ renderSpanWithHtmlContent(question) }
					{ required ? <span className="required">*Campos de preenchimento obrigatório.</span> : '' }
				</p>
				<OpenRadioInput
					question={question}
					required={required}
					value={valueField}
					valueField={valueField}
					nameField={nameField}
					disabledField={disabledField}
					classField={classField}
					classContainer={classContainer}
					onChange={onChangeField}
					options={options}
					meta={meta}
					messageErrorField={messageErrorField}
					questions={questions}
					maxInput={2}
				/>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	case 'plan-fields':
		return (
			<Plan
				question={question}
				required={required}
				valueField={valueField}
				nameField={nameField}
				classField={classField}
				classContainer={classContainer}
				onChange={onChangeField}
				options={options}
				meta={meta}
				onGetValueField={onGetValueField}
			/>
		);
	case 'warning':
		if (typeof meta.alias !== 'undefined' && meta.alias === 'template_warning') {
			return (
				<div className={`component-question-data p-0 mb-4 component-question-warning ${classContainer}`}>
					<div className="attention-box">
						<h3 className="col-12">ATENÇÃO!</h3>

						<div className="col-12 attention-content">
							<h4>SEGUE UM TEMPLATE MERAMENTE ILUSTRATIVO*</h4>

							<p className="mb-4">
								Este é apenas um exemplo. As cores utilizadas para a criação da arte serão
								selecionadas a partir de sua logo. O carro e outros elementos irão variar
								conforme as escolhas realizadas no briefing.
							</p>

							<p>
								* Para aprovação definitiva, você receberá por e-mail a sua peça
								na versão final antes da veiculação da campanha. Caso não aprove terá que refazer
								as etapas para criação, a fim de selecionar uma nova arte.
							</p>
						</div>

						<img src={TemplateIlustrativo} alt="Template meramente ilustrativo" className="img-fluid my-4" />
					</div>
				</div>
			);
		}
		return (
			<div className={`component-question-data component-question-warning ${classContainer}`}>
				<p>{ question } <a href={meta.warning_url} rel="noopener noreferrer" target="_blank">Clique aqui!</a></p>
			</div>
		);
	case 'locale-box':
		return (
			<div className={`component-question-data locale-box-question ${classContainer}`}>
				{ (meta.message !== undefined && meta.message.show)
					? (
						<div className="content-box-description mb-4">
							{meta.message.title ? <p className="title">{meta.message.title}</p> : ''}
							{meta.message.content ? renderPWithHtmlContent(meta.message.content) : ''}
						</div>
					) : ''
				}

				<p>
					{question}
				</p>
				<LocaleBox
					question={question}
					typeField={typeField}
					nameField={nameField}
					placeholderField={placeholderField}
					valueField={valueField}
					onGetValueField={onGetValueField}
					disabledField={disabledField}
					messageErrorField={messageErrorField}
					classField={classField}
					classContainer={classContainer}
					onChange={onChangeField}
					required={required}
					answers={answers}
				/>
			</div>
		);
	case 'tag-input':
		return (
			<TagInput
				question={question}
				typeField={typeField}
				nameField={nameField}
				placeholderField={placeholderField}
				valueField={valueField}
				onGetValueField={onGetValueField}
				disabledField={disabledField}
				messageErrorField={messageErrorField}
				classField={classField}
				classContainer={classContainer}
				onChange={onChangeField}
				required={required}
				meta={meta}
			/>
		);
	case 'file':
		return (
			<FileInput
				question={question}
				required={required}
				valueField={valueField}
				nameField={nameField}
				classField={classField}
				classContainer={classContainer}
				onChange={onChangeField}
				options={options}
				meta={meta}
				messageErrorField={messageErrorField}
				onGetValueField={onGetValueField}
			/>
		);
	case 'textarea':
		return (
			<div>
				<TextareaInput
					nameField={nameField}
					className={classField}
					onChange={onChangeField}
					required={required}
					valueField={valueField}
					question={question}
					classContainer={classContainer}
					disabledField={disabledField}
					messageErrorField={messageErrorField}
					meta={meta}
				/>
			</div>
		);
	default:
		return (
			<div className={`component-question-data mb-4 p-0 ${classContainer}`}>
				{ (meta.message !== undefined && meta.message.show)
					? (
						<div className="content-box-description mb-4">
							{meta.message.title ? <p className="title">{meta.message.title}</p> : ''}
							{meta.message.content ? renderPWithHtmlContent(meta.message.content) : ''}
						</div>
					) : ''
				}

				<p>
					{question}
					{required ? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}
				</p>

				<div className={meta.class_input}>
					<input
						type={typeField}
						name={nameField}
						className={classField}
						placeholder={placeholderField}
						value={valueField}
						onChange={onChangeField}
						disabled={disabledField}
					/>

					<p className="mt-1 description mb-0">{meta.description}</p>
				</div>
				<div className="help-block">{messageErrorField}</div>
			</div>
		);
	}
};

export default QuestionData;
